import { render } from "./DateOfBirth.vue?vue&type=template&id=45585f93&scoped=true"
import script from "./DateOfBirth.vue?vue&type=script&lang=js"
export * from "./DateOfBirth.vue?vue&type=script&lang=js"

import "./DateOfBirth.vue?vue&type=style&index=0&id=45585f93&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45585f93"]])

export default __exports__